import * as ScoreType from 'constants/ScoreType';
import * as GroupType from 'constants/GroupType';
import * as Period from 'constants/Period';

import * as MatchInfo from 'constants/MatchInfo';

const VOLLEYBALL_SCORE_MAP = {};
VOLLEYBALL_SCORE_MAP[Period.NOT_STARTED] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.MATCH_NOT_STARTED,
        main: ScoreType.Match
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    },
    [GroupType.FOURTH_PERIOD_GROUP]: {
        main: ScoreType.FourthPeriod
    },
    [GroupType.FIFTH_PERIOD_GROUP]: {
        main: ScoreType.FifthPeriod
    }
};

VOLLEYBALL_SCORE_MAP[Period.FIRST] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod]
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    },
    [GroupType.FOURTH_PERIOD_GROUP]: {
        main: ScoreType.FourthPeriod
    },
    [GroupType.FIFTH_PERIOD_GROUP]: {
        main: ScoreType.FifthPeriod
    }
};

VOLLEYBALL_SCORE_MAP[Period.SECOND] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod]
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    },
    [GroupType.FOURTH_PERIOD_GROUP]: {
        main: ScoreType.FourthPeriod
    },
    [GroupType.FIFTH_PERIOD_GROUP]: {
        main: ScoreType.FifthPeriod
    }
};

VOLLEYBALL_SCORE_MAP[Period.THIRD] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod]
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    },
    [GroupType.FOURTH_PERIOD_GROUP]: {
        main: ScoreType.FourthPeriod
    },
    [GroupType.FIFTH_PERIOD_GROUP]: {
        main: ScoreType.FifthPeriod
    }
};

VOLLEYBALL_SCORE_MAP[Period.FOURTH] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [ScoreType.FirstPeriod, ScoreType.SecondPeriod, ScoreType.ThirdPeriod, ScoreType.FourthPeriod]
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    },
    [GroupType.FOURTH_PERIOD_GROUP]: {
        main: ScoreType.FourthPeriod
    },
    [GroupType.FIFTH_PERIOD_GROUP]: {
        main: ScoreType.FifthPeriod
    }
};

VOLLEYBALL_SCORE_MAP[Period.FIFTH] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [
            ScoreType.FirstPeriod,
            ScoreType.SecondPeriod,
            ScoreType.ThirdPeriod,
            ScoreType.FourthPeriod,
            ScoreType.FifthPeriod
        ]
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    },
    [GroupType.FOURTH_PERIOD_GROUP]: {
        main: ScoreType.FourthPeriod
    },
    [GroupType.FIFTH_PERIOD_GROUP]: {
        main: ScoreType.FifthPeriod
    }
};

VOLLEYBALL_SCORE_MAP[Period.SIXTH] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [
            ScoreType.FirstPeriod,
            ScoreType.SecondPeriod,
            ScoreType.ThirdPeriod,
            ScoreType.FourthPeriod,
            ScoreType.FifthPeriod,
            ScoreType.SixthPeriod
        ]
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    },
    [GroupType.FOURTH_PERIOD_GROUP]: {
        main: ScoreType.FourthPeriod
    },
    [GroupType.FIFTH_PERIOD_GROUP]: {
        main: ScoreType.FifthPeriod
    },
    [GroupType.SIXTH_PERIOD_GROUP]: {
        main: ScoreType.SixthPeriod
    }
};

VOLLEYBALL_SCORE_MAP[Period.FINISHED] = {
    [GroupType.DEFAULT_GROUP]: {
        info: MatchInfo.MATCH_FINISHED,
        main: ScoreType.Match,
        additional: [
            ScoreType.FirstPeriod,
            ScoreType.SecondPeriod,
            ScoreType.ThirdPeriod,
            ScoreType.FourthPeriod,
            ScoreType.FifthPeriod,
            ScoreType.SixthPeriod
        ]
    }
};

export default VOLLEYBALL_SCORE_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Volleyball/ScoreMap.js